import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'
import Lock from '@material-ui/icons/Lock'
import Typography from '@material-ui/core/Typography'
import { memo } from 'react'

const SSL_TEXT_CAPTION = 'Wir schützen Ihre Daten'
const SSL_TEXT_HINT = 'Sichere SSL-Verschlüsselung'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    ssl: {
      color: '#339E33',
      textAlign: 'center',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: theme.spacing(6)
    },
    text: {
      marginLeft: theme.spacing(1)
    }
  })
)

const SSL = () => {
  const { ssl, text } = useStyles()

  return (
    <div className={ssl}>
      <Lock color="inherit" />
      <div className={text}>
        <Typography variant="body2" color="inherit" align="left">
          <strong>{SSL_TEXT_CAPTION}</strong>
        </Typography>
        <Typography variant="body2" color="inherit" align="left">
          {SSL_TEXT_HINT}
        </Typography>
      </div>
    </div>
  )
}

export default memo(SSL)
